(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["viewing-count"] && !Shopify.designMode) return;
  try {
    class ProductViewingCount extends HTMLElement {
    connectedCallback() {
      const minimum = Number.parseInt(this.dataset.min || '1', 10);
      const requestedMaximum = Number.parseInt(this.dataset.max || String(minimum), 10);
      const maximum = Math.max(minimum, requestedMaximum);
      const count = Math.floor(Math.random() * (maximum - minimum + 1)) + minimum;
      const template = this.dataset.template || '[count] people are viewing this product';
      const output = this.querySelector('[data-viewing-count-text]');
      if (output) output.textContent = template.replaceAll('[count]', String(count));
    }
  }

  if (!customElements.get('product-viewing-count')) {
    customElements.define('product-viewing-count', ProductViewingCount);
  }
  } catch(e) { console.error(e); }
})();

})();
